// extracted by mini-css-extract-plugin
export default {"root":"Header_root__iFlHH","layout-container":"Header_layout-container__WgYKO","headerContainer":"Header_headerContainer__qDpiS","headerLogo":"Header_headerLogo__NReGb"};
    if(module.hot) {
      // 1763446807642
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  